import EsgPlansFooter from './EsgPlansFooter';

export default EsgPlansFooter;
